import { z } from 'zod'

export const ScreenshotBoundsSchema = z.object({
  x: z.number().finite().nonnegative(), y: z.number().finite().nonnegative(),
  width: z.number().finite().positive(), height: z.number().finite().positive(),
})
export const SiteMapScreenshotItemSchema = z.object({
  itemId: z.string().min(1).max(200), bounds: ScreenshotBoundsSchema,
})
export const SiteMapFrameSchema = z.object({
  pageId: z.string().min(1).max(200), pageUrl: z.string().url().max(8000),
  capturedAtMs: z.number().int().positive(),
  width: z.number().int().positive().max(10000), height: z.number().int().positive().max(10000),
  items: z.array(SiteMapScreenshotItemSchema).min(1).max(2000),
}).refine(frame => frame.items.every(({ bounds: b }) => b.x + b.width <= frame.width && b.y + b.height <= frame.height), 'Crop must fit the frame')
export const SiteMapCaptureSchema = z.object({
  frame: SiteMapFrameSchema,
  image: z.string().max(4_000_000).regex(/^data:image\/jpeg;base64,[A-Za-z0-9+/]+={0,2}$/),
})
export const SiteMapScreenshotSchema = z.object({
  itemId: z.string(), bounds: ScreenshotBoundsSchema,
  imageUrl: z.string().url(), width: z.number().positive(), height: z.number().positive(),
  capturedAtMs: z.number().positive(), taskId: z.string(), pageUrl: z.string(), pageId: z.string(),
})
export const SiteMapScreenshotsSchema = z.array(SiteMapScreenshotSchema)
export type SiteMapScreenshot = z.infer<typeof SiteMapScreenshotSchema>
export type SiteMapCapture = z.infer<typeof SiteMapCaptureSchema>
